import ReactDOM from "react-dom";
import React, { FC, useLayoutEffect, useRef, useState } from "react";
import { Theme, styled } from "@material-ui/core/styles";

import { SIDEBAR_WIDTH } from "./AppSidebar.styles";

const FLYOUT_WIDTH = 260;
const TIP_LEFT = SIDEBAR_WIDTH + FLYOUT_WIDTH + 10;
const NAVY = "#0F2B4C";
const BORDER = "1px solid rgba(255,255,255,0.15)";

const TipTitle = styled("div")(({ theme }: { theme: Theme }) => ({
  color: theme.palette.brand.coral,
  fontWeight: 600,
  fontSize: 12,
  marginBottom: 6,
  letterSpacing: "0.02em",
}));

const TipText = styled("div")({
  fontSize: 12.5,
  lineHeight: 1.6,
  color: "rgba(255,255,255,0.8)",
  whiteSpace: "pre-line" as const,
});

export interface FlyoutTooltipProps {
  title: string;
  text: string;
  anchorRect: DOMRect | null;
  visible: boolean;
}

const FlyoutTooltip: FC<FlyoutTooltipProps> = ({ title, text, anchorRect, visible }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [top, setTop] = useState(8);

  useLayoutEffect(() => {
    if (!visible || !anchorRect) return;
    const th = ref.current?.offsetHeight ?? 140;
    let t = anchorRect.top - 4;
    if (t + th > window.innerHeight - 16) t = window.innerHeight - th - 16;
    setTop(Math.max(8, t));
  }, [visible, anchorRect]);

  return ReactDOM.createPortal(
    <div
      ref={ref}
      style={{
        position: "fixed",
        left: TIP_LEFT,
        top,
        width: 300,
        background: NAVY,
        border: BORDER,
        borderRadius: 10,
        padding: "14px 18px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        zIndex: 999,
        pointerEvents: "none",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.18s",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: -6,
          top: 14,
          width: 12,
          height: 12,
          background: NAVY,
          borderLeft: BORDER,
          borderBottom: BORDER,
          transform: "rotate(45deg)",
        }}
      />
      <TipTitle>{title}</TipTitle>
      <TipText>{text}</TipText>
    </div>,
    document.body,
  );
};

export default FlyoutTooltip;
